import { LoginUtil } from '../LoginUtil'
import {
  ErpCustomer,
  Customer,
  ErpCustomerRequestPayload,
} from '../types/api/erp'

export const CustomerTransform = {
  fromErp: (c: ErpCustomer) => {
    const {
      street,
      street2,
      zip,
      country_code,
      date,
      birth_date,
      city,
      vat,
      ...customer
    } = c
    const data = {
      ...customer,
      birth_date: date || birth_date || null,
      address: {
        country_code,
        street,
        street2: street2 || null,
        zip,
        city,
        vat,
      },
    } satisfies Customer
    return data
  },
  toErpCreate: ({
    address,
    birth_date,
    ...customer
  }: Omit<
    Customer,
    | 'id'
    | 'total'
    | 'ref'
    | 'referrer_id'
    | 'title'
    | 'email_state'
    | 'credit'
    | 'phone_state'
  >): ErpCustomerRequestPayload => {
    const mobile = customer.mobile
      ? LoginUtil.parsePhone(customer.mobile)
      : null

    return {
      ...customer,
      ...address,
      phone: customer.phone || '',
      title: null,
      date: birth_date?.split('T')[0] || birth_date,
      mobile: mobile?.nationalNumber || '',
      prefix: mobile?.countryCallingCode
        ? `+${mobile?.countryCallingCode || ''}`
        : null,
      street2: address?.street2 || null,
      country_code: address?.country_code?.toUpperCase() || 'DE',
    } satisfies ErpCustomerRequestPayload
  },
  toErpPartial: ({ address, ...customer }: Partial<Customer>) => {
    return {
      ...customer,
      ...address,
    } satisfies Partial<ErpCustomer>
  },
}
